<template>
  <div>User Profile</div>
</template>

<script>
export default {
  name: "Account"
};
</script>